import React, { forwardRef } from "react";

import { type ToggleProps, SupToggle } from "./components/Toggle";

export type RadioProps = Omit<ToggleProps, "renderIcon" | "inputType">;

const renderRadioIcon = (checked: boolean) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {checked && <path d="M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z" fill="currentColor" />}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM10 15.1429C12.8403 15.1429 15.1429 12.8403 15.1429 10C15.1429 7.15968 12.8403 4.85714 10 4.85714C7.15968 4.85714 4.85714 7.15968 4.85714 10C4.85714 12.8403 7.15968 15.1429 10 15.1429Z"
      fill="currentColor"
    />
  </svg>
);

export const SupRadio = forwardRef<HTMLInputElement, RadioProps>(function Radio(props, ref) {
  return <SupToggle ref={ref} {...props} inputType="radio" renderIcon={renderRadioIcon} />;
});
